<app-tabs-filter>
  @for (facet of facets(); track facet.id) {
    <button
      [style.cursor]="isDetaied() ? 'default' : 'pointer'"
      class="button"
      appButton type="button"
      [class]="getButtonClass(facet)"
      (click)="onSelected(facet)"
      [color]="getFacetColor(facet)"
      [noSpaces]="true">
      <app-icon icon
                [color]="selectedFacets().includes(facet.alias) ? '#ffffff' : '#063DA9'"
                [name]="getFacetIcon(facet)" size="medium"></app-icon>
      <span [class]="getFacetName(facet) ? 'ml-2': ''">
      {{ getFacetName(facet) }}
    </span>
    </button>
  }
</app-tabs-filter>
